var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import MessageBox from 'syf-component-library/ui/patterns/MessageBox';
import { Inset } from 'syf-component-library/ui/spacing';
import Icon from '../../../ui/atoms/Icon';
var ErrorSection = function (_a) {
    var errorText = _a.errorText;
    return (_jsx(Inset, __assign({ top: "large" }, { children: _jsx(MessageBox, __assign({ "data-cy": "upload-docs-error-message", type: "error", icon: _jsx(Icon, { name: "faExclamationCircle", size: "lg" }) }, { children: errorText })) })));
};
export default ErrorSection;
//# sourceMappingURL=index.js.map